import React from "react";
import "./ProfileView.css";
import { useNavigate } from "react-router-dom";
import { logout } from "../../slices/authSlice";
import { useDispatch } from "react-redux";
import LeftNavigationBar from "../LeftNavigationBar/LeftNavigationBar";
import keycloak from "../../keycloak";
import { USE_KEYCLOAK } from "../../common/utils/apiService";

const ProfileView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    navigate(-1); // Go back to the last page
  };

  const handleLogout = () => {
    dispatch(logout());
    if (USE_KEYCLOAK) {
      keycloak.logout();
    } else {
      navigate("/login"); // Redirect to home after logout when Keycloak is off
    }  };

  return (
    <div className="profileView">
      <LeftNavigationBar />
      <div className="profile-section">
        <div className="profile-view">
          <button className="profile-button logout-button" onClick={handleLogout}>Logout</button>
          <button className="profile-button close-button" onClick={handleClose}>Close</button>

          <div className="profile-header">
            <div className="profile-info">
              <p className="profile-name">Full Name</p>
              <p className="profile-text">Username/ID</p>
              <p className="profile-text">Role/Title</p>
            </div>
          </div>
          <hr />

          <div className="profile-information">
            <div className="profile-row">
              <div className="profile-section">
                <p className="profile-title">Contact Information</p>
                <p className="profile-text">Email Address: user@terraspark.io</p>
                <p className="profile-text">Phone Number: +1234567890</p>
                <p className="profile-text">Address: 123 Main St, City, Country</p>
              </div>

              <div className="profile-section">
                <p className="profile-title">Account Details</p>
                <p className="profile-text">Subscription Plan: Premium</p>
                <p className="profile-text">Billing Information: **** **** **** 1234</p>
                <p className="profile-text">Account Status: Active</p>
              </div>

              <div className="profile-section">
                <p className="profile-title">Settings</p>
                <p className="profile-text">Personal Preferences: Dark Mode</p>
                <p className="profile-text">Privacy Settings: Public</p>
                <p className="profile-text">Security Settings: 2FA Enabled</p>
              </div>
            </div>
            <div className="profile-row">

              <div className="profile-section">
                <p className="profile-title">Activity and Usage</p>
                <p className="profile-text">Recent Activity: Last login 2 hours ago</p>
                <p className="profile-text">Usage Statistics: 10GB of 50GB used</p>
              </div>

              <div className="profile-section">
                <p className="profile-title">Integration and API Keys</p>
                <p className="profile-text">Connected Apps: Google, Slack</p>
                <p className="profile-text">API Keys: ************</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileView;
